import apiClient from "@/shared/api/apiClient2";

export const getInheritanceItem = async (id) => {
  try {
    const { data } = await apiClient.get(
      `/participants-cabinet/inheritance/detail/${id}/`
    );
    return data;
  } catch (e) {
    console.error("[inheritance] getInheritanceItem", e);
  }
};
